export default {
    name: 'T.PRO',
    search: 'Поиск',
};
